import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({match}) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route path={`${match.url}dashboard`} component={asyncComponent(() => import('./Dashboard'))}/>
      <Route path={`${match.url}projects`} component={asyncComponent(() => import('./Projects'))}/>
      <Route path={`${match.url}organisations`} component={asyncComponent(() => import('../../routes/Organisations'))}/>
      <Route path={`${match.url}assessments`} component={asyncComponent(() => import('../../routes/Assessments'))}/>
      <Route path={`${match.url}user-management/roles`} component={asyncComponent(() => import('../../routes/System/Roles'))} />
      <Route path={`${match.url}user-management/users`} component={asyncComponent(() => import('../../routes/System/Users'))} />
      <Route path={`${match.url}sync`} component={asyncComponent(() => import('../../routes/System/Sync'))} />
      <Route path={`${match.url}manage-my-organisations/:id`} component={asyncComponent(() => import('../../routes/MyOrganisations'))}/>
      <Route path={`${match.url}bannerblocks`} component={asyncComponent(() => import('../../routes/Bannerblocks'))}/>
      <Route path={`${match.url}deploy`} component={asyncComponent(() => import('../../routes/System/Deploy'))}/>
    </Switch>
  </div>
);

export default App;
